import styled from 'styled-components';

export const StalePasswordField = styled.div`
  flex: 3;
  margin: 0 24px 0 0;
  min-width: 180px;
  max-width: 250px;
`;
